import React from 'react';
import styled from 'styled-components';
import Tooltip from '@ubeya/shared-web/components/Tooltip/Tooltip';
import { HELP_DESK_ICON_MAP } from '../../helpDeskConstants';

const Wrapper = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: ${({ $shrinkText }) => ($shrinkText ? '0' : 'auto')};
`;

const IconWrap = styled.span`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;

  svg {
    width: 20px;
    height: 20px;
  }
`;

const CategoryName = styled.div`
  min-width: ${({ $shrinkText }) => ($shrinkText ? '0' : 'auto')};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 20px;
  font-size: 12px;
`;

const CategoryDisplay = ({ category, compact = false, shrinkText = true }) => {
  if (!category) return null;

  const CatIconComponent = category.icon && HELP_DESK_ICON_MAP[category.icon];

  return (
    <Tooltip body={category.name}>
      <Wrapper $shrinkText={shrinkText}>
        {CatIconComponent && (
          <IconWrap style={{ color: category.color }}>
            <CatIconComponent />
          </IconWrap>
        )}
        {!compact && <CategoryName $shrinkText={shrinkText}>{category.name}</CategoryName>}
      </Wrapper>
    </Tooltip>
  );
};

export default CategoryDisplay;
